import { createAction, props } from '@ngrx/store';
import { CreditNoteModel } from '@shared/data-access/models';

export const loadItem = createAction('[CREDIT NOTE] LOAD ITEM', props<{ id: number }>());
export const loadItemSuccess = createAction('[CREDIT NOTE] LOAD ITEM SUCCESS', props<{ item: CreditNoteModel }>());
